import { Card, CardContent, CardHeader, CardTitle } from '@/common/ui/card'
import useQueryGetInviteFriendTierCounts from '../../../../api/hooks/useQueryGetInviteFriendTierCounts'
import { Skeleton } from '@/common/ui/skeleton'
import { Users } from 'lucide-react'

interface InviteFriendTierCountsProps {
	playerId: string
}

export default function InviteFriendTierCounts({
	playerId,
}: InviteFriendTierCountsProps) {
	const { data: tierCountsData, isLoading } =
		useQueryGetInviteFriendTierCounts(playerId)

	if (isLoading) {
		return (
			<div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
				{[1, 2, 3].map((i) => (
					<Card key={i}>
						<CardHeader className="pb-3">
							<Skeleton className="h-4 w-24" />
						</CardHeader>
						<CardContent className="pt-0">
							<Skeleton className="h-8 w-20" />
						</CardContent>
					</Card>
				))}
			</div>
		)
	}

	if (!tierCountsData?.tierCounts || tierCountsData.tierCounts.length === 0) {
		return (
			<div className="py-8 text-center text-muted-foreground">
				ไม่พบข้อมูลจำนวนสมาชิกตามเทียร์
			</div>
		)
	}

	return (
		<div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
			{tierCountsData.tierCounts.map((tierCount) => (
				<Card key={tierCount.tier}>
					<CardHeader className="pb-3">
						<CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
							<Users className="h-4 w-4" />
							ลำดับ {tierCount.tier}
						</CardTitle>
					</CardHeader>
					<CardContent className="pt-0">
						<div className="text-2xl font-bold">
							{tierCount.count.toLocaleString()} คน
						</div>
					</CardContent>
				</Card>
			))}
		</div>
	)
}
